export default {
  eyebrow: 'Partner portal',
  title: 'Tax & Currency',
  description: 'Default tax categories your restaurants inherit unless they override a category individually.',
};
